// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var CurPriceSource;
(function (CurPriceSource) {
    CurPriceSource[CurPriceSource["Level1"] = 0] = "Level1";
    CurPriceSource[CurPriceSource["Trades"] = 1] = "Trades";
    CurPriceSource[CurPriceSource["Level1MainOnly"] = 2] = "Level1MainOnly";
})(CurPriceSource || (CurPriceSource = {}));
